// ClientDeliveryDropdown.js
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { getHeaders } from '../../../lib/requests';

function ClientDeliveryDropdown({ clientId, onSelect }) {
  const [deliveries, setDeliveries] = useState([]);
  const [selectedDelivery, setSelectedDelivery] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const fetchDeliveries = async () => {
      try {
        const apiToken = localStorage.getItem('accessToken');
        const apiUrl = process.env.REACT_APP_API_URL;
        const endDate = new Date();
        endDate.setDate(endDate.getDate() + 30);
        const formattedEndDate = endDate.toISOString().split('T')[0];
        const response = await axios.get(`${apiUrl}/deliveries`, {
          headers: getHeaders(apiToken),
          params: {
            client_id: clientId,
            delivery_date_start: new Date().toISOString().split('T')[0],
            delivery_date_end: formattedEndDate,
            status: 'scheduled',
          },
        });
        setDeliveries(response.data.data);
      } catch (error) {
        console.error('Error fetching deliveries', error);
      }
    };

    fetchDeliveries();
  }, [clientId]);

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const handleSelectDelivery = (delivery) => {
    setSelectedDelivery(delivery);
    setShowDropdown(false); // Close the dropdown after selection
    onSelect(delivery); // Inform the parent component about the selection
  };

  const formattedSelectedDeliveryDate = selectedDelivery
    ? new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }).format(new Date(selectedDelivery.scheduled_delivery_date))
    : 'Select Delivery';

  return (
    <div className="relative inline-block text-left">
      <button
        id="dropdownDefaultButton"
        data-dropdown-toggle="dropdown"
        className={`text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 ${deliveries.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
        type="button"
        onClick={toggleDropdown}
        disabled={deliveries.length === 0}
      >
        {formattedSelectedDeliveryDate}
        <svg className="ml-2 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 8l5 5 5-5" />
        </svg>
      </button>

      {showDropdown && deliveries.length > 0 && (
        <div id="dropdown" className="absolute z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700">
          <ul className="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefaultButton">
            {deliveries.map(delivery => (
              <li key={delivery.delivery_id}>
                <a
                  href="#"
                  className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  onClick={(e) => {
                    e.preventDefault(); // Prevent the link from navigating
                    handleSelectDelivery(delivery);
                  }}
                >
                  {new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }).format(new Date(delivery.scheduled_delivery_date))}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

ClientDeliveryDropdown.propTypes = {
  clientId: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default ClientDeliveryDropdown;
